import { ReactComponent as CloseSvg } from "../../assets/icons/close.svg";

import {
  ModalContainer,
  CloseButton,
  ModalContent,
  ModalTitle,
  ModalSubtitle,
  ButtonGroup,
  ConfirmButton,
  Row,
  CancelButton,
  Input,
  Label,
  InputContainer,
  TitleColumn,
} from "./CreateFolderModal.styles";
import Modal from "../utils/Modal/Modal";
import { useLockBodyScroll } from "../../hooks/useLockBodyScroll";

const CreateFolderModal = ({
  isOpen,
  onClose,
  onConfirm,
  folderName,
  setFolderName,
  isLoading = false,
}) => {
  useLockBodyScroll(isOpen);

  const trimmedName = (folderName || "").trim();
  const isConfirmDisabled = isLoading || !trimmedName;

  const handleConfirm = () => {
    if (isConfirmDisabled) return;
    onConfirm();
  };

  const handleCancel = () => {
    if (!isLoading) {
      onClose();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !isConfirmDisabled) {
      e.preventDefault();
      handleConfirm();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      customOverlayStyles={{ zIndex: 3100 }}
    >
      <ModalContainer>
        <ModalContent>
          <Row>
            <TitleColumn>
              <ModalTitle>Create Folder</ModalTitle>
              <ModalSubtitle>
                Group your collections into a new folder.
              </ModalSubtitle>
            </TitleColumn>
            <CloseButton onClick={handleCancel}>
              <CloseSvg width={20} height={20} />
            </CloseButton>
          </Row>

          <InputContainer>
            <Label>Folder Name</Label>
            <Input
              autoFocus
              value={folderName}
              onChange={(e) => setFolderName(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="e.g. Vacation 2026"
              maxLength={60}
              disabled={isLoading}
            />
          </InputContainer>

          <ButtonGroup>
            <CancelButton onClick={handleCancel} disabled={isLoading}>
              Cancel
            </CancelButton>
            <ConfirmButton
              onClick={handleConfirm}
              $type="primary"
              disabled={isConfirmDisabled}
            >
              {isLoading ? (
                <l-bouncy size="18" speed="0.9" color="#ffffff" />
              ) : (
                "Create"
              )}
            </ConfirmButton>
          </ButtonGroup>
        </ModalContent>
      </ModalContainer>
    </Modal>
  );
};

export default CreateFolderModal;
